import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
} from "react-redux";

import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import reducers from "./reducers";

// Configuration for redux-persist
const persistConfig = {
  key: "root", // Key used in localStorage
  storage, // Storage method (localStorage in this case)
  whitelist: ["data","layout", "customizationData"], // Only 'data' and 'layout' reducers will be persisted
};

// Wrap the root reducer with persistReducer to enable persistence
const persistedReducer = persistReducer(persistConfig, reducers);

// ==============================|| MIDDLEWARE CONFIG ||============================== //

// Required to avoid warnings from redux-persist about non-serializable actions
const middleware = getDefaultMiddleware({
  serializableCheck: {
    ignoredActions: [
      "persist/PERSIST",
      "persist/REHYDRATE",
      "persist/REGISTER",
      "persist/PAUSE",
      "persist/FLUSH",
      "persist/PURGE",
    ],
  },
});

// ==============================|| STORE CONFIG ||============================== //

// Create Redux store using persisted reducer and custom middleware
const store = configureStore({
  reducer: persistedReducer,
  middleware,
});

// Get dispatch method from store for global use
const { dispatch } = store;

// ==============================|| CUSTOM HOOKS ||============================== //

// Custom typed hooks to use throughout the app
const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

// ==============================|| EXPORTS ||============================== //

export { store, dispatch, useSelector, useDispatch }; // Export store and hooks
export const persistor = persistStore(store); // Export persistor to use with <PersistGate>
